/**
 * Track which keys have already been reported, forgetting the oldest key once
 * `limit` is reached so the set cannot grow without bound.
 *
 * @example
 * const deduper = createBoundedDeduper(50);
 * deduper.shouldReport("MISSING_MESSAGE:Nav.signIn"); // → true
 * deduper.shouldReport("MISSING_MESSAGE:Nav.signIn"); // → false
 */
export function createBoundedDeduper(limit: number) {
  if (!Number.isInteger(limit) || limit <= 0) {
    throw new RangeError("limit must be a positive integer");
  }

  // A Set iterates in insertion order, so the first entry is the oldest key.
  const reported = new Set<string>();

  return {
    /** True the first time a key is seen, and again if it was evicted since. */
    shouldReport(key: string): boolean {
      if (reported.has(key)) return false;

      if (reported.size >= limit) {
        const oldest = reported.values().next().value;
        if (oldest !== undefined) reported.delete(oldest);
      }
      reported.add(key);
      return true;
    },
  };
}
